import { Capacitor } from "@capacitor/core";
// import { App } from "@capacitor/app";

import { buildInfo } from "buildInfo";

export const isNative = Capacitor.isNativePlatform();

export const nativeBuildNumber: string = buildInfo.appflowBuildNumber || "";

export const nativeBuildId: string = buildInfo.appflowBuildId || "";